(function(){
'use strict';
var D=window.FableData,root=document.querySelector('[data-fable]');
if(!D||!root)return;
var CFG=JSON.parse(root.getAttribute('data-cfg'));
var SILVER=CFG.finish==='silver',tainted=false;

var BY={},LIST={letters:[],birthstones:[],zodiac:[],heart:[]};
D.items.forEach(function(a){
  var it={id:a[0],label:a[1],cat:a[2],i:a[3],axl:a[4],axr:a[5],ay:a[6]};
  BY[it.id]=it;LIST[it.cat].push(it);
});
function short(it){return it.cat==='birthstones'?it.label.split(' · ')[1]:it.label;}
/* the supplier's shorthand for each pendant, from their SKU sheet: letters as-is, hearts (❥n), zodiac (✦n), birthstones (#month) */
function supplierCode(it){
  if(it.cat==='letters')return it.label;
  if(it.cat==='heart')return '(\u2765'+(it.i+1)+')';
  if(it.cat==='zodiac')return '(\u2726'+(it.i+1)+')';
  return '(#'+(it.i+1)+')';
}
var CATNAME={letters:'Letter',birthstones:'Birthstone',zodiac:'Zodiac',heart:'Charm'};
var TABNAME={letters:'Letters',birthstones:'Birthstones',zodiac:'Zodiac',heart:'Hearts'};

/* zodiac glyphs drawn fresh for the picker: thin strokes inside a ring, colored by finish */
var ZG={
  aries:'M50 84V40C50 24 36 16 26 25 18 33 22 45 31 47M50 40C50 24 64 16 74 25 82 33 78 45 69 47',
  taurus:'M50 88a20 20 0 1 0 0-40 20 20 0 0 0 0 40ZM28 20C34 38 41 46 50 48 59 46 66 38 72 20',
  gemini:'M38 30V70M62 30V70M25 24C40 30 60 30 75 24M25 76C40 70 60 70 75 76',
  cancer:'M34 44a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM24 34C24 20 48 18 78 26M66 56a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM76 66C76 80 52 82 22 74',
  leo:'M30 70a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM38 62C38 42 50 24 60 30 70 36 56 52 62 66 66 76 76 74 78 66',
  virgo:'M22 30V72M22 36C28 27 40 27 40 38V72M40 36C46 27 58 27 58 38V72M58 36C64 27 78 29 74 50 71 63 61 71 50 82M74 50C81 58 84 67 79 78',
  libra:'M20 62H36A14 14 0 1 1 64 62H80M20 78H80',
  scorpio:'M22 30V72M22 36C28 27 40 27 40 38V72M40 36C46 27 58 27 58 38V66C58 76 66 80 74 74M68 66L76 76L66 79',
  sagittarius:'M26 74L74 26M52 26H74V48M36 52L48 64',
  capricorn:'M20 36C28 26 36 30 38 42V64M38 42C40 30 50 26 56 32 62 38 60 48 56 60 52 74 66 80 72 70 78 60 68 54 60 60',
  aquarius:'M20 44L30 36 40 44 50 36 60 44 70 36 80 44M20 62L30 54 40 62 50 54 60 62 70 54 80 62',
  pisces:'M36 24C22 40 22 60 36 76M64 24C78 40 78 60 64 76M30 50H70'
};
function zodiacSvg(id){
  var d=ZG[id.replace('zodiac-','')]||'';
  return '<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="50" r="46" fill="none" stroke="currentColor" stroke-width="2.5"/><path d="'+d+'" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
}

var q=function(s){return root.querySelector(s);};
var cv=q('[data-fb-canvas]'),box=q('[data-fb-box]'),spin=q('[data-fb-spin]'),
    countEl=q('[data-fb-count]'),cardsEl=q('[data-fb-cards]'),progEl=q('[data-fb-progress]'),
    propsEl=q('[data-fb-props]'),idEl=q('[data-fb-id]'),priceEl=q('[data-fb-price]'),
    btnPriceEl=q('[data-fb-btnprice]'),capEl=q('[data-fb-cap]'),errEl=q('[data-fb-err]'),
    ctaEl=q('[data-fb-cta]'),formEl=q('[data-fb-form]'),
    trackEl=q('[data-fb-track]'),thumbsEl=q('[data-fb-thumbs]'),dotsEl=q('[data-fb-dots]'),tcv=q('[data-fb-thumbcanvas]');

/* nothing is chosen for the customer: no pendant count (n = 0) until they pick one, and each pendant starts with the question, not a list */
var MAXN=CFG.variants.reduce(function(m,v){return Math.max(m,v.count);},1);
var S={n:0,open:0,cats:[null,null,null,null,null,null],picks:[null,null,null,null,null,null]};
var ORD=['first','second','third','fourth','fifth','sixth'];
var HASPHOTOS=!!root.querySelector('.fable__gallery.has-photos');
var KEY='fable2:'+location.pathname;

/* a design carried over from the other finish (URL) or from earlier in this visit (session) */
function serialize(){return S.n+':'+S.picks.slice(0,6).map(function(x){return x||'';}).join(',');}
function restore(str){
  if(!str)return false;
  var m=/^([1-6]):(.*)$/.exec(str);if(!m)return false;
  var ids=m[2].split(',');
  S.n=Math.min(+m[1],MAXN);
  for(var i=0;i<6;i++){var id=ids[i]||'';S.picks[i]=id&&BY[id]?id:null;S.cats[i]=S.picks[i]?BY[id].cat:null;}
  return true;
}
(function(){
  var fromUrl=new URLSearchParams(location.search).get('fable'),saved=null;
  try{saved=sessionStorage.getItem(KEY);}catch(e){}
  if(!restore(fromUrl))restore(saved);
  var fe=firstEmptyInit();S.open=fe>=0?fe:-1;
  function firstEmptyInit(){for(var i=0;i<S.n;i++)if(!S.picks[i])return i;return -1;}
})();
function persist(){
  var str=S.n?serialize():'';
  try{if(str)sessionStorage.setItem(KEY,str);else sessionStorage.removeItem(KEY);}catch(e){}
  root.querySelectorAll('.fable__finish a:not([aria-current="true"])').forEach(function(a){
    var u=a.getAttribute('href').split('?')[0];a.setAttribute('href',str?u+'?fable='+encodeURIComponent(str):u);
  });
}

/* ---------- images ---------- */
var imgs={},sheets={},chainP=null,bgP=null;
function loadImg(u){
  if(imgs[u])return imgs[u];
  imgs[u]=new Promise(function(res,rej){
    var im=new Image();im.crossOrigin='anonymous';
    im.onload=function(){res(im);};im.onerror=function(){rej(new Error(u));};
    im.src=u;
  });
  return imgs[u];
}
function silverize(im){
  var w=im.naturalWidth||im.width,h=im.naturalHeight||im.height;
  var c=document.createElement('canvas');c.width=w;c.height=h;
  var x=c.getContext('2d',{willReadFrequently:true});
  x.drawImage(im,0,0);
  var d;
  try{d=x.getImageData(0,0,w,h);}catch(e){tainted=true;return null;}
  var p=d.data,L=D.lut,i,lum,f,v;
  for(i=0;i<p.length;i+=4){
    if(!p[i+3])continue;
    lum=0.299*p[i]+0.587*p[i+1]+0.114*p[i+2];
    f=lum|0;if(f>254)f=254;
    v=L[f]+(L[f+1]-L[f])*(lum-f);
    p[i]=p[i+1]=p[i+2]=v;
  }
  x.putImageData(d,0,0);return c;
}
function sheetUrl(cat,idx){
  var u=CFG.urls[cat],fin=(D.cats[cat].derive||!SILVER)?'gold':'silver';
  return cat==='heart'?u[fin]:u[fin][idx];
}
function getSheet(cat,idx){
  var k=cat+idx;
  if(sheets[k])return sheets[k];
  var derive=D.cats[cat].derive&&SILVER;
  sheets[k]=loadImg(sheetUrl(cat,idx)).then(function(im){
    if(!derive)return im;
    return silverize(im)||im;
  });
  return sheets[k];
}
function getPlate(u){
  return loadImg(u).then(function(im){
    if(!SILVER)return im;
    return silverize(im)||im;
  });
}
function getChain(){return chainP||(chainP=getPlate(CFG.urls.chain));}
function getBg(){return bgP||(bgP=getPlate(CFG.urls.bg));}

/* ---------- geometry ---------- */
function P(t){
  var ch=D.chain,x=ch.x,y=ch.y,s=ch.s,i=1,n=s.length;
  while(i<n-1&&s[i]<t)i++;
  var f=(t-s[i-1])/Math.max(s[i]-s[i-1],1e-9);
  return [x[i-1]+f*(x[i]-x[i-1]),y[i-1]+f*(y[i]-y[i-1])];
}
/* where each pendant sits: chain arc positions of its two bail ends, and the chord angle */
function layout(ids){
  var ch=D.chain,n=ids.length,sp=n<2?0:Math.min(ch.step,ch.maxSpan/(n-1)),out=[];
  for(var k=0;k<n;k++){
    var mid=ch.s0+(k-(n-1)/2)*sp,it=ids[k]?BY[ids[k]]:null;
    if(!it){out.push({mid:mid});continue;}
    var c=D.cats[it.cat],len=(it.axr-it.axl)*c.sc,sl=mid-len/2,sr=sl+len,a,b,d;
    for(var j=0;j<3;j++){a=P(sl);b=P(sr);d=Math.hypot(b[0]-a[0],b[1]-a[1]);sr+=len-d;}
    a=P(sl);b=P(sr);
    out.push({mid:mid,it:it,c:c,sl:sl,sr:sr,a:a,ang:Math.atan2(b[1]-a[1],b[0]-a[0])});
  }
  return out;
}

/* ---------- paint ---------- */
var token=0;
var HOV=null;
function render(){
  if(!S.n)return;
  var t=++token,ids=S.picks.slice(0,S.n);
  if(HOV&&HOV.i<S.n&&BY[HOV.id])ids[HOV.i]=HOV.id;
  var jobs=[getChain(),getBg()];
  ids.forEach(function(id){
    if(!id){jobs.push(null);return;}
    var it=BY[id];jobs.push(getSheet(it.cat,Math.floor(it.i/D.cats[it.cat].per)));
  });
  Promise.all(jobs).then(function(r){
    if(t!==token)return;
    paint(r[0],r[1],ids,r.slice(2));
    spin.hidden=true;
    if(!warmed){if(window.requestIdleCallback)window.requestIdleCallback(warmPhotos,{timeout:1500});else setTimeout(warmPhotos,300);}
    if(tcv){var tx=tcv.getContext('2d');tx.clearRect(0,0,tcv.width,tcv.height);tx.drawImage(cv,0,0,tcv.width,tcv.height);}
  })['catch'](function(e){
    if(window.console)console.error('[fable]',e);
    spin.hidden=false;spin.textContent='Preview unavailable';
  });
}
var FILT='grayscale(1) brightness(1.12) contrast(.96)';
function paint(chain,bg,ids,sh){
  var dpr=Math.min(window.devicePixelRatio||1,2);
  var size=Math.max(360,Math.min(Math.round((box.clientWidth||520)*dpr),1400));
  if(cv.width!==size){cv.width=size;cv.height=size;}
  var ctx=cv.getContext('2d');
  ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,size,size);
  var fb=SILVER&&tainted,K=size/D.canvas,ch=D.chain,g=layout(ids),k,o;
  if(fb)ctx.filter=FILT;
  ctx.drawImage(chain,0,0,size,size);
  /* 1. cut the chain out of every span a pendant occupies (bails overlap the cut ends) */
  ctx.save();ctx.beginPath();
  for(k=0;k<g.length;k++){
    o=g[k];if(!o.it)continue;
    var p=P(o.sl+ch.ov),r=P(o.sr-ch.ov),w=ch.cut*K/2,dx=r[0]-p[0],dy=r[1]-p[1],L=Math.hypot(dx,dy)||1,nx=-dy/L*w,ny=dx/L*w;
    ctx.moveTo(p[0]*K+nx,p[1]*K+ny);ctx.lineTo(r[0]*K+nx,r[1]*K+ny);
    ctx.lineTo(r[0]*K-nx,r[1]*K-ny);ctx.lineTo(p[0]*K-nx,p[1]*K-ny);ctx.closePath();
  }
  ctx.clip();ctx.drawImage(bg,0,0,size,size);ctx.restore();
  if(fb)ctx.filter='none';
  /* 2. hang each pendant from its two bail ends */
  for(k=0;k<g.length;k++){
    o=g[k];
    if(!o.it){placeholder(ctx,o.mid,k,K);continue;}
    var it=o.it,c=o.c,cw=c.cell[0],chh=c.cell[1],sy=(it.i%c.per)*chh,sc=c.sc;
    var dw=c.crop[2]*sc*K,dh=c.crop[3]*sc*K,on=fb&&c.derive;
    if(on)ctx.filter=FILT;
    ctx.save();
    ctx.translate(o.a[0]*K,o.a[1]*K);
    ctx.rotate(o.ang);
    ctx.drawImage(sh[k],0,sy,cw,chh,-(it.axl-c.crop[0])*sc*K,-(it.ay-c.crop[1])*sc*K,dw,dh);
    ctx.restore();
    if(on)ctx.filter='none';
  }
}
function placeholder(ctx,mid,k,K){
  var p=P(mid),r=30*K,cx=p[0]*K,cy=p[1]*K+r*1.5,line=SILVER?'rgba(120,120,125,.8)':'rgba(170,140,90,.85)';
  ctx.save();
  ctx.lineWidth=Math.max(1,1.6*K);ctx.strokeStyle=line;
  ctx.beginPath();ctx.moveTo(cx,p[1]*K+4*K);ctx.lineTo(cx,cy-r);ctx.stroke();
  ctx.setLineDash([5*K,4*K]);
  ctx.fillStyle='rgba(255,255,255,.6)';
  ctx.beginPath();ctx.arc(cx,cy,r,0,Math.PI*2);ctx.fill();ctx.stroke();
  ctx.setLineDash([]);
  ctx.fillStyle=SILVER?'rgba(100,100,105,.9)':'rgba(140,112,64,.95)';
  ctx.font=Math.round(19*K)+'px sans-serif';ctx.textAlign='center';ctx.textBaseline='middle';
  ctx.fillText(String(k+1),cx,cy+0.5*K);
  ctx.restore();
}

/* ---------- ui ---------- */
function el(tag,cls,html){var e=document.createElement(tag);if(cls)e.className=cls;if(html!=null)e.innerHTML=html;return e;}
function esc(s){return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});}
function firstEmpty(){for(var i=0;i<S.n;i++)if(!S.picks[i])return i;return -1;}
function priceFor(n){for(var i=0;i<CFG.variants.length;i++)if(CFG.variants[i].count===n)return CFG.variants[i];return CFG.variants[0];}

function thumbStyle(it){
  var n=LIST[it.cat].length,pos=n>1?(it.i/(n-1)*100):0;
  return 'background-image:url('+CFG.thumbs[it.cat]+');background-size:'+(n*100)+'% 100%;background-position:'+pos+'% 50%';
}
function thumbHtml(it,big){
  /* letters show as the plain letter in the necklace's metal (same picker style as the Sora), not the pendant photo */
  if(it.cat==='letters')return '<span class="fable__glyph fable__glyph--'+(SILVER?'silver':'gold')+(big?' is-big':'')+'" aria-hidden="true">'+esc(it.label)+'</span>';
  if(it.cat==='zodiac')return '<span class="fable__thumb fable__thumb--glyph'+(big?' is-big':'')+'">'+zodiacSvg(it.id)+'</span>';
  return '<span class="fable__thumb'+(big?' is-big':'')+'" style="'+thumbStyle(it)+'"></span>';
}

function drawCount(){
  countEl.innerHTML='';
  if(!S.n){var ph=document.createElement('option');ph.value='';ph.textContent='Choose how many pendants';ph.disabled=true;ph.selected=true;countEl.appendChild(ph);}
  CFG.variants.slice().sort(function(a,b){return a.count-b.count;}).forEach(function(v){
    var o=document.createElement('option');
    o.value=v.count;o.textContent=v.count+(v.count===1?' pendant':' pendants')+'  \u2014  '+v.price;
    if(v.count===S.n)o.selected=true;countEl.appendChild(o);
  });
}
var ANS=[
  {cat:'letters',name:'Letter',sub:'An initial, A to Z',grid:'letter'},
  {cat:'birthstones',name:'Birthstone',sub:'For a birth month',grid:'birthstone'},
  {cat:'zodiac',name:'Zodiac',sub:'For a star sign',grid:'zodiac sign'},
  {cat:'heart',name:'Heart',sub:'Red or pink',grid:'heart'}
];
function drawCards(){
  cardsEl.innerHTML='';
  if(!S.n){progEl.textContent='';return;}
  var fe=firstEmpty(),last=fe>=0?fe:S.n-1;
  for(var i=0;i<=last;i++){
    var it=S.picks[i]?BY[S.picks[i]]:null,open=i===S.open,cat=S.cats[i];
    var card=el('div','fable__card'+(open?' is-open':'')+(it?' is-done':' is-empty'));
    card.dataset.card=i;
    var sub=it?esc(CATNAME[it.cat]+': '+short(it)):(open?'':'Not chosen yet');
    var cta=open?(it?'Close':''):(it?'Change':'Choose');
    var head=el('button','fable__card-head',
      '<span class="fable__card-num">'+(i+1)+'</span>'+
      '<span class="fable__card-text"><span class="fable__card-title">Pendant '+(i+1)+(S.n>1?' <small>of '+S.n+'</small>':'')+'</span>'+
      (sub?'<span class="fable__card-sub">'+sub+'</span>':'')+'</span>'+
      (it?thumbHtml(it,false):'')+
      (cta?'<span class="fable__card-cta">'+cta+'</span>':''));
    head.type='button';head.dataset.open=i;head.setAttribute('aria-expanded',open?'true':'false');
    card.appendChild(head);
    if(open){
      var body=el('div','fable__card-body');
      body.appendChild(el('p','fable__q','What would you like on your '+(ORD[i]||'next')+' pendant?'));
      var ans=el('div','fable__answers'+(cat?' is-compact':''));
      ANS.forEach(function(a){
        var ex=LIST[a.cat][0];
        var b=el('button','fable__ans',(ex?thumbHtml(ex,false):'')+'<span class="fable__ans-text"><b>'+a.name+'</b><small>'+a.sub+'</small></span>');
        b.type='button';b.dataset.cat=a.cat;b.dataset.card=i;
        b.setAttribute('aria-pressed',a.cat===cat?'true':'false');ans.appendChild(b);
      });
      body.appendChild(ans);
      if(cat){
        var a0=ANS.filter(function(a){return a.cat===cat;})[0];
        body.appendChild(el('p','fable__q2','Choose your '+(a0?a0.grid:'pendant')+'<span class="fable__hint"> &middot; hover to see it on your necklace</span>'));
        var grid=el('div','fable__grid fable__grid--'+cat);
        LIST[cat].forEach(function(o){
          var lab=o.cat==='birthstones'?'<b>'+esc(o.label.split(' · ')[1])+'</b><small>'+esc(o.label.split(' · ')[0])+'</small>':'<b>'+esc(o.label)+'</b>';
          var b=o.cat==='letters'?el('button','fable__tile fable__tile--letter',thumbHtml(o,true)):el('button','fable__tile',thumbHtml(o,true)+'<span class="fable__tile-lab">'+lab+'</span>');
          b.type='button';b.dataset.pick=o.id;b.dataset.card=i;
          b.setAttribute('aria-pressed',o.id===S.picks[i]?'true':'false');
          b.setAttribute('aria-label',o.cat==='heart'?o.label:CATNAME[o.cat]+' '+o.label);
          grid.appendChild(b);
        });
        body.appendChild(grid);
      }
      card.appendChild(body);
    }
    cardsEl.appendChild(card);
  }
  var done=0;for(var k=0;k<S.n;k++)if(S.picks[k])done++;
  progEl.textContent=done===S.n?'All '+S.n+' chosen':done+' of '+S.n+' chosen';
}
function sync(){
  var v=priceFor(S.n||1),empty=firstEmpty();
  idEl.value=v.id;
  priceEl.innerHTML=S.n?esc(v.price)+' <small>&middot; '+S.n+(S.n===1?' pendant':' pendants')+'</small>':'From '+esc(priceFor(1).price);
  if(btnPriceEl)btnPriceEl.textContent=v.price;
  var ids=S.picks.slice(0,S.n),names=[];
  propsEl.innerHTML='';
  ids.forEach(function(id,k){
    var it=id?BY[id]:null,val=it?(it.cat==='heart'?it.label:CATNAME[it.cat]+': '+it.label):'';
    names.push(it?val:'Pendant '+(k+1)+': not chosen yet');
    if(!it)return;
    var inp=document.createElement('input');
    inp.type='hidden';inp.name='properties[Pendant '+(k+1)+']';inp.value=val;
    propsEl.appendChild(inp);
  });
  var codes=ids.map(function(id){return id?supplierCode(BY[id]):'?';});
  [['_Supplier SKU',(v.sku||'')+' '+codes.join(' ')],['_fable_ids',ids.join('|')],['_fable_finish',CFG.finish]].forEach(function(p){
    var i2=document.createElement('input');i2.type='hidden';i2.name='properties['+p[0]+']';i2.value=p[1];
    propsEl.appendChild(i2);
  });
  if(capEl)capEl.textContent=names.join('  ·  ');
  ctaEl.disabled=!S.n||empty>=0;
  if(pstepEl)pstepEl.hidden=!S.n;
  errEl.hidden=true;
}
var view=0,pstepEl=q('[data-fb-pstep]');
function off(){return (!S.n&&HASPHOTOS)?1:0;}
function markView(i){
  view=i;
  if(thumbsEl)thumbsEl.querySelectorAll('[data-fb-view]').forEach(function(b){var on=+b.dataset.fbView===i;b.classList.toggle('is-on',on);b.setAttribute('aria-selected',on?'true':'false');});
  if(dotsEl)Array.prototype.forEach.call(dotsEl.children,function(d,k){d.classList.toggle('is-on',k===i);});
}
/* the slider photos are lazy-loaded; once the preview is drawn, fetch them in the background so each one is ready before the customer swipes to it */
var warmed=false;
function warmPhotos(){
  if(warmed||!trackEl)return;warmed=true;
  trackEl.querySelectorAll('img[loading="lazy"]').forEach(function(im){im.decoding='async';im.loading='eager';});
}
/* a thumbnail click glides straight to that photo; the dots and thumbnails hold on the target instead of flickering through the photos in between */
var jumpTo=-1,jumpT;
function goTo(i,smooth){
  if(!trackEl)return;
  var w=trackEl.clientWidth;
  jumpTo=smooth?i:-1;clearTimeout(jumpT);
  if(smooth)jumpT=setTimeout(function(){jumpTo=-1;},900);
  var x=w*Math.max(0,i-off());
  if(trackEl.scrollTo)trackEl.scrollTo({left:x,behavior:smooth?'smooth':'auto'});else trackEl.scrollLeft=x;
  markView(i);
}
function showDesign(){if(view!==0)goTo(0,false);}
if(thumbsEl)thumbsEl.addEventListener('click',function(e){
  var b=e.target.closest('[data-fb-view]');if(b)goTo(+b.dataset.fbView,true);
});
if(trackEl){
  /* the dots and thumbnails follow the photos while they glide (once per frame), instead of waiting for the swipe to stop */
  var raf=0;
  trackEl.addEventListener('scroll',function(){
    if(raf)return;
    raf=requestAnimationFrame(function(){
      raf=0;
      var w=trackEl.clientWidth||1,i=Math.round(trackEl.scrollLeft/w)+off();
      if(jumpTo>=0){if(i!==jumpTo)return;jumpTo=-1;}
      if(i!==view)markView(i);
    });
  },{passive:true});
  trackEl.addEventListener('touchstart',function(){jumpTo=-1;warmPhotos();},{passive:true});
}
function stageState(){
  var hide=off()===1,was=root.classList.contains('fable--nocount');
  root.classList.toggle('fable--nocount',hide);
  if(hide&&view===0)markView(1);
  if(was&&!hide){view=-1;goTo(0,false);}
}
function refresh(){stageState();drawCards();sync();persist();render();if(S.n)showDesign();}
function hh(){return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'),10)||0;}
/* once the last pendant is chosen, glide up to the finished necklace (skipped when it is already on screen, e.g. the sticky desktop preview) */
function showPreview(){
  var g=root.querySelector('.fable__gallery')||root,r=g.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;
  if(r.height&&(Math.min(r.bottom,vh)-Math.max(r.top,0))/r.height>=0.6)return;
  window.scrollTo({top:Math.max(0,r.top+window.pageYOffset-hh()-10),behavior:'smooth'});
}
function scrollToCard(i){
  var c=cardsEl.querySelector('[data-card="'+i+'"]');if(!c)return;
  var t=c.getBoundingClientRect().top,vh=window.innerHeight||document.documentElement.clientHeight;
  if(t<hh()+10||t>vh*0.7)window.scrollTo({top:Math.max(0,t+window.pageYOffset-hh()-16),behavior:'smooth'});
}

countEl.addEventListener('change',function(){
  if(!countEl.value)return;
  var first=!S.n;
  S.n=+countEl.value;
  var ph=countEl.querySelector('option[value=""]');if(ph)ph.remove();
  var fe=firstEmpty();
  S.open=fe>=0?fe:-1;
  refresh();
  if(first)scrollToCard(S.open>=0?S.open:0);
});
cardsEl.addEventListener('click',function(e){
  var t=e.target;
  var pick=t.closest('button[data-pick]');
  if(pick){
    var i=+pick.dataset.card;
    S.picks[i]=pick.dataset.pick;S.cats[i]=BY[pick.dataset.pick].cat;
    /* guide forward: open the next empty pendant; when the last one is chosen, show them the finished necklace */
    HOV=null;
    var fe=firstEmpty();
    S.open=fe>=0?fe:-1;
    refresh();
    if(S.open>=0)scrollToCard(S.open);else showPreview();
    return;
  }
  var tab=t.closest('button[data-cat]');
  if(tab){HOV=null;S.cats[+tab.dataset.card]=tab.dataset.cat;drawCards();return;}
  var head=t.closest('button[data-open]');
  if(head){var j=+head.dataset.open;S.open=S.open===j?-1:j;if(HOV){HOV=null;render();}drawCards();}
});
/* desktop: hovering an option shows it on the necklace in that pendant's spot; moving off the options puts the chosen design back */
var canHover=window.matchMedia&&window.matchMedia('(hover: hover) and (pointer: fine)').matches,hovT;
if(canHover){
  cardsEl.addEventListener('mouseover',function(e){
    var b=e.target.closest&&e.target.closest('button[data-pick]'),next=b?{i:+b.dataset.card,id:b.dataset.pick}:null;
    if(!next&&!HOV)return;
    if(next&&HOV&&next.i===HOV.i&&next.id===HOV.id)return;
    if(next&&view!==0)return;
    clearTimeout(hovT);
    hovT=setTimeout(function(){HOV=next;render();},next?40:120);
  });
  cardsEl.addEventListener('mouseleave',function(){clearTimeout(hovT);if(HOV){HOV=null;render();}});
}
formEl.addEventListener('submit',function(e){
  if(!S.n){e.preventDefault();e.stopImmediatePropagation();errEl.textContent='Choose how many pendants you would like first.';errEl.hidden=false;countEl.focus();return;}
  var fe=firstEmpty();
  if(fe>=0){e.preventDefault();e.stopImmediatePropagation();errEl.textContent='Choose a pendant for position '+(fe+1)+' to finish your necklace.';errEl.hidden=false;S.open=fe;drawCards();scrollToCard(fe);}
});

/* phones fire resize when the address bar collapses mid-scroll; only redraw the preview when its width actually changes */
var rt,lastW=box.clientWidth;
window.addEventListener('resize',function(){
  clearTimeout(rt);
  rt=setTimeout(function(){
    var w=box.clientWidth;
    if(w===lastW)return;
    lastW=w;render();
    if(view)goTo(view,false);
  },180);
});

drawCount();refresh();
})();